import React from 'react';
import styled, { css } from 'styled-components';
import { Typography } from 'src/typography';
import { centsToDollars } from 'src/payments/utils';
import { InstoreCartItem as CartItem } from 'src/payments/hooks/use-get-instore-cart/types';

export function InstoreCartItem({ item }: { item: CartItem }): JSX.Element {
  return (
    <Item>
      <Info>
        <Brand>{item.brandName}</Brand>
        <Title>{item.name}</Title>
        {item.quantity && <Quantity>{item.quantity}</Quantity>}
      </Info>
      <Price>{centsToDollars(item.valueCents)}</Price>
    </Item>
  );
}

const Item = styled.li`
  ${({ theme: { colors, spaces } }) => css`
    color: ${colors.grey[30]};
    display: grid;
    grid-template-columns: 1fr ${spaces[12]};
    grid-column-gap: ${spaces[4]};
    align-items: center;
    margin-bottom: ${spaces[4]};
  `}
`;

const Brand = styled(Typography.Heading).attrs({
  tag: 'h3',
  size: 'xxsmall',
})`
  ${({ theme: { colors } }) => css`
    color: ${colors.grey[70]};
  `}
`;

const Title = styled(Typography.Body).attrs({
  size: 'medium',
  weight: 'bold',
})`
  line-height: 23px;
`;

const Quantity = styled(Typography.Body).attrs({
  size: 'xsmall',
})`
  line-height: 18px;
`;

const Info = styled.div``;

const Price = styled(Typography.Body).attrs({
  size: 'small',
  weight: 'bold',
})`
  text-align: right;
`;
